import { render, staticRenderFns } from "./rightCenter.vue?vue&type=template&id=649ae856&"
import script from "./rightCenter.vue?vue&type=script&lang=js&"
export * from "./rightCenter.vue?vue&type=script&lang=js&"
import style0 from "./rightCenter.vue?vue&type=style&index=0&id=649ae856&prod&lang=scss&class=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports